import lessRequire from '../../../../config/less-require-resolver';
import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { connect } from 'react-redux';
import classname from 'classname';
import { Link } from 'react-router';

import { displayType, selectors } from '../../single';

import inputField from '../../../shared/form-elements/input';
import selectField from '../../../shared/form-elements/select';
import checkboxField from '../../../shared/form-elements/checkbox';
import radioField from '../../../shared/form-elements/radio';
import Tooltip from '../../../shared/tooltip';
import DomainParkingSection from '../../../shared/form-elements/domain-parking';

import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';

import { baseUrl } from '../../../../config/route-entry-point';

import List from '../display-type/list';
import Tile from '../display-type/tile';
import OfferGeos from './offer-geo-stats';
import AdditionalRules from './additional-rules';
import RulesPopup from './../../components/popups/rules';

import {list as externalOfferDomains} from '../../../../../shared/js/externalOfferDomains';

lessRequire('modules/streams/components/stream-form/part-main.less');

const isEverad = process.env.CPA_ENV === 'everad';

const volatiles = {
	parkingDomain: isEverad ? 'parking.everad.com' : 'parking.rocketprofit.com',
	getRedirectDomains: (domains) => isEverad ? domains : externalOfferDomains
};

const landingFiledDomainNames = {
	domainType: 'redirect_domain_type',
	subdomain: 'internal_redirect_subdomain',
	internalDomain: 'internal_redirect_domain',
	externalDomain: 'external_redirect_domain'
};

const PartMain = (props) => {
	const { active, list } = props.sections;
	const {
		columnSorting,
		lists,
		sortByColumn,
		landingTransitHeaders,
		fetchLangugeRules,
		setDefaultLanguage,
		setDefaultCountryCode,
		saveManualTouch,
		intl,
		resetCurrency,
		canEdit
	} = props;

	const isExternalLandingAvail = !isEverad || get(props, 'formData.values.landing_domain_type') === 'external';
	const isExternalTransitAvail = !isEverad || get(props, 'formData.values.transit_domain_type') === 'external';

	const className = classname({
		'stream-form__main': true,
		'active': active === list.main
	});

	const { landings, transitions, selectedOffer } = props.tableData;

	const LandingsView = displayType.list === landings.displayType && List || Tile;
	const TransitionsView = displayType.list === transitions.displayType && List || Tile;

	const addPaddingForLandClass = props.domainTooltipStatus.shouldShowForLanding ? 'add-padding-bottom' : '';
	const addPaddingForTransitClass = props.domainTooltipStatus.shouldShowForTransit ? 'add-padding-bottom' : '';

	let countryCode = get(props, 'formData.values.country_code') || '';
	if (countryCode.label && countryCode.value) {
		countryCode = countryCode.value;
	}

	const isAnyPopupAvailable = props.popupsAvailability.customer_popups_available ||
		props.popupsAvailability.mouseout_popup_available ||
		props.popupsAvailability.phone_button_popup_available ||
		props.popupsAvailability.additional_phone_available;

	return (
		<div className={className}>
			<div className="stream-form__main-meta clearfix">
				<div className="stream-form__main-meta__fields">
					<div
						className="stream-form__main-field first "
						id="title"
					>
						<Field name="title"
							placeholder={intl('Имя потока')}
							component={inputField}
							errors={props.formData.errors}
							shouldDisable={(!props.isOtherAdv && props.isEditMode) || (props.isEditMode && !canEdit)}
						/>
					</div>

					<div className="stream-form__main-field">
						<Field name="user_offer"
							placeholder={intl('Оффер')}
							component={selectField}
							loadOptions={props.getOffersOptions}
							searchable={true}
							errors={props.formData.errors}
							shouldDisable={props.isEditMode}
							onChange={(val) => {
								props.fetchOffer(val.value);
								props.fetchOfferStats(val.value);
							}}
						/>
					</div>

					<div className="stream-form__main-field left half-field">
						<Field name="country_code"
							placeholder={intl('Гео')}
							component={selectField}
							shouldDisable={props.isEditMode || isEmpty(selectedOffer)}
							searchable={true}
							onChange={(event, param) => {
								setDefaultLanguage(param.value);
								resetCurrency();
								saveManualTouch('country_code');
							}}
							errors={props.formData.errors}
							options={props.selectOptions.geos}/>
					</div>

					<div className="stream-form__main-field half-field language">
						<Field name="language"
							placeholder={intl('Язык')}
							component={selectField}
							shouldDisable={props.isEditMode || isEmpty(selectedOffer)}
							searchable={true}
							errors={props.formData.errors}
							onChange={(event, param) => {
								fetchLangugeRules(param.value);
								setDefaultCountryCode(param.value);
								saveManualTouch('language');
							}}
							options={props.selectOptions.languages}/>
					</div>

					<div className="stream-form__main-field half-field left" id="traffic_source" >
						<Field name="traffic_source"
							placeholder={intl('Источник трафика')}
							component={selectField}
							shouldDisable={isEmpty(selectedOffer) || (props.isEditMode && !canEdit)}
							searchable={false}
							errors={props.formData.errors}
							options={props.trafficSources}
						/>
					</div>
					{ props.selectedCurrency && props.selectedCurrency.value === -1 && (
						<div className="currency-error font-proxima-nova-regular">
							<i>{intl('У вас не подключено ни одной из валют, доступных для этого офера')}</i>
						</div>
					)}
				</div>

				{ !isEmpty(selectedOffer) && !isEmpty(props.offerGeoStats) && (
					<div className="stream-form__main-meta__geostats-wrap clearfix">
						<OfferGeos {...props} />
					</div>
				) }
				{ !isEmpty(selectedOffer) && !isEmpty(props.offerGeoStats) && (
					<AdditionalRules
						countryCode={countryCode}
						offer={selectedOffer}
						lists={lists}
					/>
				) }
			</div>

			{ landings && landings.paginated && !isEmpty(landings.paginated.data) && (
				<div className="stream-form__main-table">
					<div className="content-container__title">
						<h2 className="font-proxima-nova-bold">{intl('Лендинг')}</h2>

						{isEverad && (
							<div className="display-type__switch header-switch">
								<div className="header-switch__links">
									<a href="#"
										className={classname({
											'tile-view': true,
											active: displayType.tile === landings.displayType
										})}
										onClick={ e => {
											e.preventDefault();
											displayType.tile === landings.displayType || props.changeDisplayType('landings');
										}} />

									<a href="#"
										className={classname({
											'list-view': true,
											active: displayType.list === landings.displayType
										})}
										onClick={ e => {
											e.preventDefault();
											displayType.list === landings.displayType || props.changeDisplayType('landings');
										}} />
								</div>
							</div>
						)}
					</div>

					<div className="content-container__body" id="domains">
						{ props.formData.errors && props.formData.errors.dataPath
							&& props.formData.errors.dataPath == '.domains' && (
							<p className="has-error">{intl('Выберите, пожалуйста, лендинг')}</p>
						) }

						<LandingsView
							{...props}
							data={landings}
							isOtherAdv={props.isOtherAdv}
							isEditMode={props.isEditMode}
							type="landings"
							tableHeaders={landingTransitHeaders}
							columnSorting={columnSorting.landing}
							sortByColumn={sortByColumn.bind(null, 'landing')}
							showMore={props.pagination().showMore}
							shouldShowSplitTooltip={props.shouldShowSplitTooltip}
							changeSection={props.changeSection}
							sections={props.sections}
							streamId={props.params.streamId}
						/>

						{ (props.isOtherAdv || props.isMyTargetAdv) && (
							<div className={ props.isMyTargetAdv
								? `park-domain clearfix my-target ${addPaddingForLandClass}`
								: `park-domain clearfix ${addPaddingForLandClass}`
							}
							>
								{/*@todo use shared park-domain form*/}
								<div className="park-domain__section internal_landing_domain">
									<div className="park-domain-row">
										<Field name="landing_domain_type"
											defaultValue="internal"
											labelText={intl('Использовать наш домен')}
											errors={props.formData.errors}
											shouldDisable={(!props.isOtherAdv && props.isEditMode) || (props.isEditMode && !canEdit)}
											component={radioField} />
									</div>

									<div className="park-domain-row clearfix">
										<div className="park-domain__field-inline">
											<Field name="internal_landing_subdomain"
												placeholder={intl('Сабдомен')}
												errors={props.formData.errors}
												shouldDisable={
													props.formData.disabledStatus.internal_landing_subdomain
													|| (!props.isOtherAdv && props.isEditMode)
													|| (props.isEditMode && !canEdit)
												}
												component={inputField}   />
											{ props.domainTooltipStatus.shouldShowForLanding && (
												<Tooltip>
													{intl('Оставьте поле пустым и сабдомен будет сгенерирован автоматически.')}
												</Tooltip>
											) }
										</div>

										<div className="park-domain__field-inline">
											<Field name="internal_landing_domain"
												placeholder={intl('Домен')}
												shouldDisable={
													props.formData.disabledStatus.internal_landing_domain
													|| (!props.isOtherAdv && props.isEditMode)
													|| (props.isEditMode && !canEdit)
												}
												component={selectField}
												errors={props.formData.errors}
												options={props.selectOptions.campaignDomains} />
										</div>
									</div>
								</div>

								<div className="park-domain__section external_landing_domain">
									{
										isExternalLandingAvail &&
										<div className="park-domain-row">
											<Field name="landing_domain_type"
												defaultValue="external"
												labelText={intl('Припарковать домен')}
												errors={props.formData.errors}
												shouldDisable={(!props.isOtherAdv && props.isEditMode) || (props.isEditMode && !canEdit)}
												component={radioField} />
										</div>
									}
									{
										isExternalLandingAvail &&
										<div className="park-domain__field-inline">
											<Field name="external_landing_domain"
												placeholder={intl('Домен')}
												errors={props.formData.errors}
												shouldDisable={
													props.formData.disabledStatus.external_landing_domain
													|| (!props.isOtherAdv && props.isEditMode)
													|| (props.isEditMode && !canEdit)
												}
												component={inputField}  />
										</div>
									}
								</div>
								<div className="park-domain__section">
									{
										isExternalLandingAvail
											? <InstructionsSection intl={intl}/>
											: <InstructionsSectionSimple intl={intl}/>
									}
								</div>
							</div>
						)}
						{ props.isOtherAdv && isAnyPopupAvailable && (
							<div className='stream-form__advanced'>
								<span className="title">{props.intl('Дополнительно')}</span>
								<div className="stream-form__advanced-checkbox-wrap">
									{ props.popupsAvailability.customer_popups_available
										&& (<Field
											name="customer_popups_enabled"
											className="form-element-checkbox mb-10"
											labelText={intl('Попап "количество заказчиков"')}
											component={checkboxField}
											shouldDisable={props.isEditMode && !canEdit}
										/>)}
									{ props.popupsAvailability.mouseout_popup_available
										&& (<Field
											name="mouseout_popup_enabled"
											className="form-element-checkbox mb-10"
											labelText={intl('Попап при уводе мышки за экран')}
											component={checkboxField}
											shouldDisable={props.isEditMode && !canEdit}
										/>)}
									{ props.popupsAvailability.phone_button_popup_available
										&& (<Field
											name="phone_button_popup_enabled"
											className="form-element-checkbox mb-10"
											labelText={intl('Попап "коллбэк"')}
											component={checkboxField}
											shouldDisable={props.isEditMode && !canEdit}/>)}
									{ props.popupsAvailability.additional_phone_available
										&& (<Field
											name="additional_phone_enabled"
											className="form-element-checkbox mb-10"
											labelText={intl('Доп.телефон')}
											component={checkboxField}
											shouldDisable={props.isEditMode && !canEdit}
										/>)
									}
								</div>
							</div>
						) }
					</div>
				</div>
			) }

			{ transitions && transitions.paginated && !isEmpty(transitions.paginated.data) && props.isOtherAdv && (
				<div className="stream-form__main-table transit-page">
					<div className="content-container__title">
						<h2 className="font-proxima-nova-bold">{intl('Транзитные страницы')}</h2>
						<div className="transit-page-disable__row">
							<Field name="disable-transit-page"
								labelText={intl('Не использовать')}
								isSlide={true}
								component={checkboxField}
								shouldDisable={props.isEditMode && !canEdit} />
						</div>

						{isEverad && (
							<div className="display-type__switch header-switch">
								<div className="header-switch__links">
									<a href="#"
										className={classname({
											'tile-view': true,
											active: displayType.tile === transitions.displayType
										})}
										onClick={ e => {
											e.preventDefault();
											displayType.tile === transitions.displayType || props.changeDisplayType('transitions');
										}} />

									<a href="#"
										className={classname({
											'list-view': true,
											active: displayType.list === transitions.displayType
										})}
										onClick={ e => {
											e.preventDefault();
											displayType.list === transitions.displayType || props.changeDisplayType('transitions');
										}} />
								</div>
							</div>
						)}
					</div>

					<div className="content-container__body">

						{ !props.shouldShowStatus.disableTransitPage && (
							<div>
								{<TransitionsView
									{...props}
									data={transitions}
									isOtherAdv={props.isOtherAdv}
									type="transitions"
									tableHeaders={landingTransitHeaders}
									columnSorting={columnSorting.transit}
									sortByColumn={sortByColumn.bind(null, 'transit')}
									showMore={props.pagination().showMore}
									shouldShowSplitTooltip={props.shouldShowSplitTooltip}
									changeSection={props.changeSection}
									sections={props.sections}
									streamId={props.params.streamId}
								/>}

								<div className={`park-domain clearfix ${addPaddingForTransitClass}`}>

									<div className="park-domain__section">
										<div className="park-domain-row">
											<Field name="transit_domain_type"
												defaultValue="internal"
												labelText={intl('Использовать наш домен')}
												errors={props.formData.errors}
												shouldDisable={props.isEditMode && !canEdit}
												component={radioField} />
										</div>

										<div className="park-domain-row clearfix">
											<div className="park-domain__field-inline">
												<Field name="internal_transit_subdomain"
													placeholder={intl('Сабдомен')}
													errors={props.formData.errors}
													shouldDisable={
														props.formData.disabledStatus.internal_transit_subdomain
														|| (props.isEditMode && !canEdit)
													}
													component={inputField}  />
												{ props.domainTooltipStatus.shouldShowForTransit && (
													<Tooltip>
														{intl('Оставьте поле пустым и сабдомен будет сгенерирован автоматически.')}
													</Tooltip>
												) }
											</div>

											<div className="park-domain__field-inline">
												<Field name="internal_transit_domain"
													placeholder={intl('Домен')}
													errors={props.formData.errors}
													shouldDisable={
														props.formData.disabledStatus.internal_transit_domain
														|| (props.isEditMode && !canEdit)
													}
													component={selectField}
													options={props.selectOptions.campaignDomains} />
											</div>
										</div>
									</div>

									<div className="park-domain__section">
										{
											isExternalTransitAvail &&
											<div className="park-domain-row">
												<Field name="transit_domain_type"
													defaultValue="external"
													labelText={intl('Припарковать домен')}
													errors={props.formData.errors}
													shouldDisable={props.isEditMode && !canEdit}
													component={radioField}
												/>
											</div>
										}
										{
											isExternalLandingAvail &&
											<div className="park-domain__field-inline">
												<Field name="external_transit_domain"
													placeholder={intl('Домен')}
													errors={props.formData.errors}
													shouldDisable={
														props.formData.disabledStatus.external_transit_domain
														|| (props.isEditMode && !canEdit)
													}
													component={inputField}  />
											</div>
										}
									</div>

									<div className="park-domain__section">
										{
											isExternalTransitAvail
												? <InstructionsSection intl={intl}/>
												: <InstructionsSectionSimple intl={intl}/>
										}
									</div>
								</div>
							</div>
						) }

					</div>

					{ isEverad && !isEmpty(selectedOffer) &&  (
						<div className="new-landing-transit-link">
							<span className="sad-smile-icon" />
							<span>
								{intl('Не нашли нужные лендинг или транзитку? Отправьте')}
								<a href={baseUrl(`tickets/request/new-landing/${selectedOffer.id}/`)}
									target="_blank">
									{intl('запрос на добавление!')}
								</a>
							</span>
						</div>
					) }
					{ !isEverad && (
						<div style={{ marginTop: 30 }} />
					) }

				</div>
			) }
			{!isEmpty(selectedOffer) && selectedOffer.use_redirect &&
				<DomainParkingSection
					{...props}
					fieldNames={landingFiledDomainNames}
					disabledStatus={props.formData.disabledStatus}
					domainOptions={volatiles.getRedirectDomains(props.selectOptions.campaignDomains)}
					shouldShowTooltip={props.domainTooltipStatus.shouldShowForRedirect}
					InstructionsSection={InstructionsSection}
					errors={props.formData.errors}
				/>
			}
			{ !props.isOtherAdv
				&& props.isEditMode
				|| !props.isNewOrEditingActiveCampaign
				|| isEmpty(selectedOffer)
				|| !landings.paginated
				|| isEmpty(get(landings, 'paginated.data'))
				?
				null :
				(props.isEditMode && !canEdit) ?
					(
						<button className={classname({
							'button stream-submit font-proxima-nova-semibold': true,
							'margin-top': selectedOffer.use_redirect,
							'disabled-btn': props.isSaveLoader
						})}>
							{intl('Клонировать поток')}
						</button>
					) :
					(
						<button className={classname({
							'button stream-submit font-proxima-nova-semibold': true,
							'margin-top': selectedOffer.use_redirect,
							'disabled-btn': props.isSaveLoader
						})} onClick={e => {
							if (props.geo_rules) {
								e.preventDefault();
								props.toggleRulesPopup();
							}
						}}>
							{props.isSaveLoader ? intl('Сохраняю поток') : intl('Сохранить поток')}
						</button>
					)
			}
			{props.isRulesPopupVisible &&
				<RulesPopup {...props} selectedOffer={selectedOffer}/>
			}
		</div>
	);
};

const InstructionsSection = ({ intl }) => (
	<p>
		{intl('Для прикрепления домена, вам необходимо добавить в панель регистратора: CNAME на')}&nbsp;
		<span>{volatiles.parkingDomain}</span>
		{' '}
		{intl('(в том числе для поддоменов)')}
	</p>
);

const InstructionsSectionSimple = ({ intl }) => (
	<p>
		{intl('Для прикрепления персонального домена, обратитесь в')}&nbsp;
		<Link to="tickets/request/add-personal-domain">
			{intl('поддержку!')}
		</Link>
	</p>
);

InstructionsSection.propTypes = {
	intl: PropTypes.func
};

PartMain.propTypes = {
	sections: PropTypes.object,
	tableData: PropTypes.object,
	formData: PropTypes.object,
	isOtherAdv: PropTypes.bool,
	isEditMode: PropTypes.bool,
	isNewOrEditingActiveCampaign: PropTypes.bool,
	selectOptions: PropTypes.object,
	changeAdvSystem: PropTypes.func,
	changeDisplayType: PropTypes.func,
	sortByColumn: PropTypes.func,
	langSelected: PropTypes.string,
	showMore: PropTypes.func,
	shouldShowSplitTooltip: PropTypes.bool,
	isSaveLoader: PropTypes.bool,
	changeSection: PropTypes.func,
	isMyTargetAdv: PropTypes.bool,
	isRulesPopupVisible: PropTypes.bool,
	domainTooltipStatus: PropTypes.object,
	shouldShowStatus: PropTypes.object,
	offerGeoStats: PropTypes.object,
	toggleGeoStats: PropTypes.func,
	toggleRulesPopup: PropTypes.func,
	fetchOffer: PropTypes.func,
	fetchOfferStats: PropTypes.func,
	changeCurrency: PropTypes.func,
	fetchLangugeRules: PropTypes.func,
	setDefaultLanguage: PropTypes.func,
	saveManualTouch: PropTypes.func,
	selectedCurrency: PropTypes.object,
	landingTransitHeaders: PropTypes.object,
	columnSorting: PropTypes.object,
	pagination: PropTypes.func,
	getOffersOptions: PropTypes.func,
	intl: PropTypes.func,
	popupsAvailability: PropTypes.object,
	params: PropTypes.object,
	chain: PropTypes.object
};

export default connect(state => selectors.trafficSources(state))(PartMain);



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/streams/components/stream-form/part-main.js